module.exports = __webpack_public_path__ + "img/shmakova.2b18d087.jpg";